import React, {useEffect} from "react";
import ProjComp from "./ProjComp";
import "./Project.css";
import MoreProject from "./MoreProject";
import { Link } from "react-router-dom";

import AOS from "aos";
import "aos/dist/aos.css";

function Project() {

  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

  return (
    <div className="Project" id="project">
      <div className="head" data-aos={"fade-up"} data-aos-delay="300">
        <div className="head-main" >
          <h4>03.</h4>
          <h2>Some Projects I've Built</h2>
        </div>
      </div>

      <div className="project-list">
        <ProjComp name="Netflix Clone" desc="Netflix UI clone application project fetches the movie data from a third-party API. It also has trailer pop-ups functionality implemented into it.The clone has been built using React JS, React-hooks, Material-UI, TMDB API, and Firebase (hosting and Deploying)." tech="ReactJS Firebase TMDB API MaterialUI" imgSrc="./Netflix-React-min.png"   />

        <ProjComp name="Instagram Clone" desc="The project includes User Authentication, Creation of Posts by uploading images and caption to Realtime-Database, and Commenting on Posts. The clone has been built using React JS, Redux, React-hooks, Styled-component, Material-UI, and Firebase " tech="ReactJS Firebase MaterialUI" imgSrc="./insta.png"  />       

        <ProjComp name="Amazon Clone" desc="A Full-Stack E-Commerce Website with user authentication, payment options, add to cart option and much more. The Project has been built using React JS, Material UI, Firebase, React-Hooks and Context API." tech="ReactJS Firebase Context API" imgSrc="./amazon-head-min.png"  />
      </div>

      <MoreProject />
      <div className="show" data-aos={"fade-up"} data-aos-delay="600">
        <Link to="/archive/" className="show-all">
            <a >Show All</a>
        </Link>
      </div>

    </div>

  );
}

export default Project;
